<template>
  <div>
    <table-view
      class="mt-24"
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :isTableLoading="isTableLoading"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="AR DATA"
      :right-btn-options="{ text: 'Download', isHavePermission: true }"
    />
    <table-view
      v-if="this.$store.state.customerTypeList.length === 1 ? false : true"
      class="mt-24"
      ref="tableList2"
      :tableModel="tableModel2"
      :tableData="tableData2"
      :pages="pages2"
      :isTableLoading="isTableLoading2"
      @pageChange="handlePageChange2"
      @changeTitleActionBtn="handleTitleActionBtn2"
      tableCardTitle="Total AR DATA"
      :right-btn-options="{ text: 'Download', isHavePermission: true }"
    />
    <el-card>
      <div slot="header" class="cart-header-wrapper">
        <span>AR Date Chart</span>
        <el-radio-group
          id="ar-radio-wrapper"
          button-style="solid"
          slot="extra"
          v-model="chartModel"
          size="large"
          @change="handleRadioClick"
        >
          <el-radio-button label="date">By Date</el-radio-button>
          <el-radio-button label="month">By Month</el-radio-button>
        </el-radio-group>
      </div>

      <v-chart :options="chartOptions" />
    </el-card>
  </div>
</template>

<script>
import {
  getTableData,
  download,
  getByDate,
  getByMonth,
  getTableData2,
} from './api'
import { getSelectList } from '@/api'

export default {
  data() {
    const searchModel = [
      {
        label: 'CCA',
        type: 'select',
        placeholder: 'All',
        key: 'cca',
        selectList: [],
        layout: {
          md: 24,
          lg: 10,
        },
      },
      {
        label: 'A/R Date',
        type: 'time',
        key: 'time',
        layout: {
          md: 24,
          lg: 10,
        },
      },
    ]
    const tableModel = [
      {
        minWidth: 100,
        label: 'AR Date',
        prop: 'date',
      },
      // {
      //   width: 120,
      //   label: 'AR aging',
      //   prop: 'agingCurrent',
      // },
      {
        width: 130,
        label: 'Total AR Balance',
        prop: 'arAmount',
      },
      {
        width: 130,
        label: 'Current bucket',
        prop: 'currentBucket',
      },
      {
        width: 130,
        label: 'Pastdue 1 - 30',
        prop: 'overdueOne',
      },
      {
        width: 130,
        label: 'Pastdue 31 - 60',
        prop: 'overdueThirty',
      },
      {
        width: 130,
        label: 'Pastdue 61 - 90',
        prop: 'overdueSixty',
      },
      {
        width: 130,
        label: 'Pastdue 91 - 180',
        prop: 'overdueNinety',
      },
      {
        width: 130,
        label: '180+ Pastdue',
        prop: 'overdueHundredEighty',
      },
      {
        width: 130,
        label: 'Backlog',
        prop: 'amountBacklog',
      },
      {
        width: 130,
        label: 'Total Exposure',
        prop: 'totalExposure',
      },
      {
        width: 130,
        label: 'CCA',
        prop: 'cca',
      },
    ]
    const tableModel2 = [
      {
        minWidth: 100,
        label: 'AR Date',
        prop: 'date',
      },
      // {
      //   width: 120,
      //   label: 'AR aging',
      //   prop: 'agingCurrent',
      // },
      {
        width: 130,
        label: 'Total AR Balance',
        prop: 'arAmount',
      },
      {
        width: 130,
        label: 'Current bucket',
        prop: 'currentBucket',
      },
      {
        width: 130,
        label: 'Pastdue 1 - 30',
        prop: 'overdueOne',
      },
      {
        width: 130,
        label: 'Pastdue 31 - 60',
        prop: 'overdueThirty',
      },
      {
        width: 130,
        label: 'Pastdue 61 - 90',
        prop: 'overdueSixty',
      },
      {
        width: 130,
        label: 'Pastdue 91 - 180',
        prop: 'overdueNinety',
      },
      {
        width: 130,
        label: '180+ Pastdue',
        prop: 'overdueHundredEighty',
      },
      {
        width: 130,
        label: 'Backlog',
        prop: 'amountBacklog',
      },
      {
        width: 130,
        label: 'Total Exposure',
        prop: 'totalExposure',
      },
      {
        width: 130,
        label: 'CCA',
        prop: 'cca',
      },
    ]
    return {
      searchModel,
      tableModel,
      tableModel2,
      tableData: [],
      tableData2: [],
      pages: {},
      pages2: {},
      visible: false,
      form: {},
      positionList: [],
      isTableLoading: true,
      isTableLoading2: true,
      chartOptions: {
        // x 轴
        xAxis: {
          type: 'category',
          // 默认是 true x 轴两侧会有一些距离，
          boundaryGap: false,
          data: [],
        },
        // y 轴
        yAxis: {
          type: 'value',
        },
        // 系列对应图表
        series: [
          {
            name: 'Total Overdue',
            data: [],
            type: 'line',
            // 面积区域配置
            areaStyle: {
              color: '#4a86e0',
            },
            //让线条更加平滑, 别直来直去
            // smooth: true,
          },
          {
            name: 'Current bucket',
            data: [],
            type: 'line',
            // 面积区域配置
            areaStyle: {
              color: '#4daf32',
            },
            //让线条更加平滑, 别直来直去
            // smooth: true,
          },
          {
            name: 'AR',
            data: [],
            type: 'line',
            // 面积区域配置
            areaStyle: {
              color: '#858EBD',
            },
            //让线条更加平滑, 别直来直去
            // smooth: true,
          },
          {
            name: 'Total Exposure',
            data: [],
            type: 'line',
            // 面积区域配置
            areaStyle: {
              color: '#e1aea8',
            },
            //让线条更加平滑, 别直来直去
            // smooth: true,
          },
        ],
        tooltip: {
          trigger: 'axis',
        },
      },
      chartModel: 'date',
      companyId: this.$route.params.customerId,
    }
  },
  mounted() {
    this._getSelectList('CCA')
    this.initTable()
    this._getTableData2()
    this._getByDate()
  },
  methods: {
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData({
        ...params,
        companyId: this.$route.params.customerId,
      })
    },
    async _getSelectList(typeMark) {
      try {
        const res = await getSelectList(typeMark)
        this.searchModel[0].selectList = res.map(item => ({
          ...item,
          id: item.name,
        }))
      } catch (err) {
        console.error(err)
      }
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        for (var i in this.tableData) {
          const filterArData = [
            'agingCurrent',
            'arAmount',
            'currentBucket',
            'overdueOne',
            'overdueNinety',
            'overdueThirty',
            'overdueSixty',
            'overdueHundredEighty',
            'amountBacklog',
            'totalExposure',
          ]
          filterArData.forEach(key => {
            const value = this.tableData[i][key]
            this.tableData[i][key] = this.$utils.formatAmount2(value)
          })
        }
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    async _getTableData2(pageParams) {
      this.isTableLoading2 = true
      const params = this.$refs.tableList.getSearchData()

      const submitData = {
        cca: params.cca,
        companyId: this.$route.params.customerId,
      }
      if (pageParams?.current) {
        submitData.current = pageParams.current
      }

      try {
        const { data, page } = await getTableData2(submitData)
        this.tableData2 = data

        for (var i in this.tableData2) {
          const filterArData = [
            'agingCurrent',
            'arAmount',
            'currentBucket',
            'overdueOne',
            'overdueNinety',
            'overdueThirty',
            'overdueSixty',
            'overdueHundredEighty',
            'amountBacklog',
            'totalExposure',
          ]
          filterArData.forEach(key => {
            const value = this.tableData2[i][key]
            this.tableData2[i][key] = this.$utils.formatAmount2(value)
          })
        }
        this.pages2 = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading2 = false
    },
    handleSearchChange(params) {
      const _params = {
        ...params,
        companyId: this.$route.params.customerId,
      }
      _params.current = 1
      this._getTableData(_params)
    },
    handlePageChange(params) {
      console.log(params, 123123)

      const _params = {
        ...params,
        companyId: this.$route.params.customerId,
      }
      this._getTableData(_params)
    },
    handlePageChange2(params) {
      this._getTableData2(params)
    },
    async handleTitleActionBtn() {
      const params = this.$refs.tableList.getSearchData()
      await download({
        ...params,
        companyId: this.$route.params.customerId,
      })
    },
    async handleTitleActionBtn2() {
      const params = this.$refs.tableList.getSearchData()
      await download({
        ...params,
        companyId: this.$route.params.customerId,
      })
    },
    async _getByDate() {
      try {
        const { xAxis, seriesAR, seriesCB, seriesTO, seriesTE } =
          await getByDate(this.companyId)
        this.chartOptions.xAxis.data = xAxis
        this.chartOptions.series[0].data = seriesTO
        this.chartOptions.series[1].data = seriesCB
        this.chartOptions.series[2].data = seriesAR
        this.chartOptions.series[3].data = seriesTE
      } catch (err) {
        console.error(err)
      }
    },
    async _getByMonth() {
      try {
        const { xAxis, seriesAR, seriesCB, seriesTO, seriesTE } =
          await getByMonth(this.companyId)
        this.chartOptions.xAxis.data = xAxis
        this.chartOptions.series[0].data = seriesTO
        this.chartOptions.series[1].data = seriesCB
        this.chartOptions.series[2].data = seriesAR
        this.chartOptions.series[3].data = seriesTE
      } catch (err) {
        console.error(err)
      }
    },
    handleRadioClick(res) {
      if (res === 'month') {
        this._getByMonth()
      } else if (res === 'date') {
        this._getByDate()
      }
    },
  },
}
</script>

<style lang="less">
.echarts {
  width: 100%;
}
</style>
